import { breakpointsOptions } from "./breakpoints";
import { paletteOptions } from "./palette";
import { ThemeOptions } from "@mui/material/styles";

export const SANS_FONT_STACK = [
  "var(--font-sans)",
  "-apple-system",
  "BlinkMacSystemFont",
  "Segoe UI",
  "Roboto",
  "Helvetica Neue",
  "sans-serif",
].join(",");

export const HEADING_FONT_STACK = [
  "var(--font-heading)",
  "Georgia",
  "serif",
].join(",");
const MONO_FONT_STACK = [
  "Menlo",
  "Consolas",
  "Monaco",
  "Liberation Mono",
  "Lucida Console",
  "monospace",
].join(",");

export const typographyOptions: ThemeOptions["typography"] = () => ({
  /**
   * HTML FONT SIZE
   * These breakpoints are mirrored from `common.css` and are for Material UI
   * to know what the HTML font size is (so that any calculations are done in
   * the context of that rem size)
   */
  htmlFontSize: 16,
  [`@media (max-width:${breakpointsOptions.values.sm})`]: {
    htmlFontSize: 14,
  },
  [`@media (max-width:${breakpointsOptions.values.xsm})`]: {
    htmlFontSize: 13,
  },
  fontFamily: SANS_FONT_STACK,

  /**
   * VARIANTS
   * If you add a new variant,
   * - Add it to `ui/@types/theme.d.ts` typing so TS picks it up correctly
   * - Add the `variantMapping` to ./components`, otherwise MUI will default
   *   the element to <span>
   */
  page_title: {
    fontFamily: HEADING_FONT_STACK,
    fontSize: "1.6rem",
    fontWeight: 700,
    lineHeight: 1.15,
    letterSpacing: "-0.02rem",
  },
  new_h2: {
    fontFamily: HEADING_FONT_STACK,
    fontSize: "1.25rem",
    fontWeight: 700,
    lineHeight: 1.15,
    letterSpacing: "-0.02rem",
  },
  new_h3: {
    fontFamily: HEADING_FONT_STACK,
    fontSize: "1.15rem",
    fontWeight: 700,
    lineHeight: 1.15,
    letterSpacing: "-0.02rem",
  },
  body1: {
    lineHeight: 1.45,
    letterSpacing: 0,
  },
  disclaimer: {
    fontSize: "0.85rem",
    fontWeight: "normal",
    lineHeight: 1.4,
    color: paletteOptions.dream.grayMediumDark,
  },
  overline: {
    fontSize: "0.8rem",
    letterSpacing: "0.02rem",
    fontWeight: "bold",
    lineHeight: 1.25,
  },
  mono: {
    fontFamily: MONO_FONT_STACK,
    fontSize: "0.9em",
  },
  label: {
    fontSize: "1.05rem",
    fontWeight: 700,
  },
});
